module.exports = __webpack_public_path__ + "img/indus-pic-7.da4a625f.png";